'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel = require('./carousel');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_carousel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }